import React, { useCallback } from 'react';
import Gear from '@uber/base-icons/gear';
import { useStyletron } from 'baseui';
import { Button, KIND, SHAPE, SIZE as BUTTON_SIZE } from 'baseui/button';
import { Checkbox } from 'baseui/checkbox';
import { SIZE, StyledDivider } from 'baseui/divider';
import { useAtom } from 'jotai';
import { batchSettingsAtom } from '../atoms/batch-atoms';
import { BATCH_SETTINGS } from './constants';
const SETTINGS_OPTIONS = Object.values(BATCH_SETTINGS).map(value => ({
  key: value,
  label: value.split('-').join(' ').charAt(0).toUpperCase() + value.split('-').join(' ').slice(1).toLowerCase()
}));
const SettingOption = ({
  label,
  onClick,
  isChecked,
  disabled
}: {
  label: string;
  onClick: () => void;
  isChecked: boolean;
  disabled?: boolean;
}) => {
  const [_, theme] = useStyletron();
  return <Button kind={KIND.secondary} shape={SHAPE.pill} size={BUTTON_SIZE.small} onClick={onClick} disabled={disabled} overrides={{
    Root: {
      style: {
        whiteSpace: 'nowrap'
      }
    }
  }} startEnhancer={() => <Checkbox checked={isChecked} disabled={disabled} overrides={{
    Root: {
      style: {
        width: theme.sizing.scale600,
        height: theme.sizing.scale600,
        alignItems: 'center'
      }
    },
    Checkmark: {
      style: ({
        $checked
      }) => ({
        height: theme.sizing.scale500,
        width: theme.sizing.scale500,
        borderRadius: theme.borders.radius200,
        border: `${theme.sizing.scale0} solid ${disabled ? theme.colors.contentStateDisabled : theme.colors.contentPrimary}`,
        backgroundColor: $checked ? disabled ? theme.colors.contentStateDisabled : theme.colors.contentPrimary : null
      })
    }
  }} />}>
      {label}
    </Button>;
};
type BatchSettingsProps = {
  disabledKeys?: Set<string>;
};
export const BatchSettings = ({
  disabledKeys
}: BatchSettingsProps) => {
  const [css, theme] = useStyletron();
  const [batchSettings, setBatchSettings] = useAtom(batchSettingsAtom);
  const handleSettingClick = (key: string) => {
    setBatchSettings(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  return <>
      <div className={css({
      display: 'flex',
      flexDirection: 'row',
      gap: theme.sizing.scale600,
      justifyContent: 'space-between',
      marginBottom: theme.sizing.scale600
    })}>
        <div className={css({
        display: 'flex',
        flexDirection: 'row',
        gap: theme.sizing.scale300,
        overflow: 'auto'
      })}>
          {SETTINGS_OPTIONS.map(option => <SettingOption key={option.key} label={option.label} onClick={() => handleSettingClick(option.key)} isChecked={batchSettings[option.key]} disabled={disabledKeys?.has(option.key)} />)}
        </div>
        <Button kind={KIND.secondary} shape={SHAPE.pill} size={BUTTON_SIZE.small} startEnhancer={() => <Gear />}>
          {`(${Object.values(batchSettings).filter(Boolean).length})`}
        </Button>
      </div>
      <StyledDivider $size={SIZE.cell} style={{
      width: '100%',
      marginBottom: theme.sizing.scale600
    }} />
    </>;
};